import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";

const SmsSettings = () => {
  const smsProviders = [
    { id: "twilio", name: "Twilio", icon: "gateway-03.svg", status: "Connected" },
    { id: "nexmo", name: "Nexmo (Vonage)", icon: "gateway-01.svg", status: "Not Connected" },
    { id: "plivo", name: "Plivo", icon: "Plivo-Logo- 1.svg", status: "Not Connected" },
    { id: "infobip", name: "Infobip", icon: "infobip.svg", status: "Not Connected" },
    { id: "msg91", name: "MSG91", icon: "MSG91.svg", status: "Not Connected" },
    { id: "clicksend", name: "ClickSend", icon: "clicksend.svg", status: "Not Connected" },
    { id: "telesign", name: "Telesign", icon: "telesign.svg", status: "Not Connected" },
    { id: "2factor", name: "2Factor", icon: "gateway-02.svg", status: "Connected" }

  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="page-title">
                    <i className="ti ti-device-mobile-message text-primary me-2" />
                    SMS Settings</h4>
                </div>
                <div className="col-4 text-end">
                  <div className="head-icons">
                    <CollapseHeader />
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row p-2 m-2" >
                  <h4>SMS Providers</h4>
                  {smsProviders.map((provider) => (
                    <div className="col-md-6 mt-2" key={provider.id}>
                    
                      <div className="border rounded p-3 mb-4">
                        <div className="row gy-3">
                          <div className="col-sm-5">
                            <div className="d-flex align-items-center">
                              <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                <ImageWithBasePath
                                  src={`assets/img/icons/${provider.icon}`}
                                  className="w-auto h-auto"
                                  alt=""
                                />
                              </span>
                              <div>
                                <h6 className="fw-medium mb-1">{provider.name}</h6>
                                <Link to="#" className={`badge bg-soft-${provider.status === "Connected" ? "success" : "danger"}`}>
                                  {provider.status}
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-7">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <Link to="#" className="me-3 text-default">
                                  <i className="ti ti-info-circle-filled me-1" />
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#${provider.id}_modal`}
                                >
                                  <i className="ti ti-tool me-1" /> View Integration
                                </Link>
                              </div>
                              <div className="status-toggle">
                                <input type="checkbox" id={provider.id} className="check" defaultChecked={provider.status === "Connected"} />
                                <label htmlFor={provider.id} className="checktoggle" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals for SMS Providers */}
      {smsProviders.map((provider) => (
        <div className="modal fade" id={`${provider.id}_modal`} role="dialog" key={provider.id}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{provider.name} Settings</h5>
                <button className="btn-close custom-btn-close border p-1 me-0 text-dark" data-bs-dismiss="modal" aria-label="Close">
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="col-form-label">API Key <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3">
                    <label className="col-form-label">API Secret <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3">
                    <label className="col-form-label">Sender ID <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="modal-footer">
                  <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">Cancel</Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SmsSettings;